import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import style from './style.module.less';

const LabeledRow = ({ label, labelFor = null, children, className = null, tooltip = null, labelClassName = null }) => (
  <div className={classnames(style.row, className)}>
    <div className={style['tooltip-for-labeled-row']}>{tooltip}</div>
    <label className={labelClassName} htmlFor={labelFor}>
      {label}
    </label>
    <div className={style.children}>{children}</div>
  </div>
);

LabeledRow.propTypes = {
  label: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  labelFor: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  tooltip: PropTypes.node,
};

export default LabeledRow;
